<template lang="html">
  <div>
    <v-dialog
      v-model="showOverlapsDialog"
      :max-width="350"
      scrollable
    >
      <v-card>
        <v-card-title>
          <div class="headline">
            Overlapping Meal Periods
          </div>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <p>The following Meal Periods overlap:</p>
          <ul>
            <li
              v-for="(mpId, i) in showOverlaps"
              :key="i"
            >
              <a @click="openMealPeriod(mpId)">{{ mealPeriodLookup[mpId].name }}</a>
            </li>
          </ul>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            class="red--text darken-1"
            text
            @click="showOverlapsDialog = false"
          >
            Done
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <meal-periods-item
      v-model="selectedItemId"
      :clone-id="cloneId"
    />
    <v-card
      v-if="!showItemOnly"
      :key="instanceKey"
    >
      <page-bar
        :title="pageTitle"
        :context-menu="defaultContextMenu"
        :loading="isDataLoading"
      />

      <api-errors :errors="errors" />

      <!-- LIST OF ITEMS -->
      <item-select-table
        :add-action="addNewItem"
        :add-label="'Add ' + type"
        :edit-action="editItem"
        :search="true"
        :items="items"
        :pagination.sync="pagination"
        :total-items="totalListItems"
        :headers="typeof headers === 'function' ? headers() : headers"
      >
        <template
          slot="availableSunday"
          slot-scope="props"
        >
          <v-chip-group column>
            <template v-if="!hasAllDays(props.item)">
              <template v-for="(day, i) of daysProper">
                <v-chip
                  v-if="props.item['available' + day]"
                  :key="i"
                >
                  {{ daysShort[i] }}
                </v-chip>
              </template>
            </template>
            <v-chip
              v-else
              key="all"
            >
              All
            </v-chip>
          </v-chip-group>
        </template>
        <template
          slot="startMonth"
          slot-scope="props"
        >
          <span v-if="props.item.startMonth">{{ getShortMonth(props.item.startMonth) }} {{ getOrdDay(props.item.startDay) }} - {{ getShortMonth(props.item.endMonth) }} {{ getOrdDay(props.item.endDay) }}</span>
        </template>
        <template
          slot="startTime"
          slot-scope="props"
        >
          {{ formatTime(props.item.startTime) }} to {{ formatTime(props.item.endTime) }}
        </template>
        <template
          slot="overlappingIds"
          slot-scope="props"
        >
          <v-btn
            v-if="props.item.overlappingIds && props.item.overlappingIds[0]"
            icon
            @click.stop="showOverlaps = props.item.overlappingIds"
          >
            <v-icon>
              mdi-vector-link
            </v-icon>
          </v-btn>
        </template>
      </item-select-table>
    </v-card>
  </div>
</template>

<script>
import moment from 'moment'
import {values, itemSelect} from '@/ft-vue-core'
import MealPeriodsItem from './MealPeriodsItem'

const {daysShort, daysProper} = values

export default {
  name: 'MealPeriodsList',
  components: {MealPeriodsItem},
  mixins: [itemSelect],
  data: function () {
    return {
      type: 'Meal Period',
      types: 'Meal Periods',
      showOverlaps: [],
      headers: () => [
        this.headerText('Meal Period Name', 'name', true),
        this.headerSlot('Time', 'startTime', true),
        this.headerText('Location', 'locationName', true),
        this.headerText('Table Config', 'tableConfigName', true),
        this.headerSlot('Days', 'availableSunday'),
        this.headerSlot('Seasonal', 'startMonth'),
        this.headerText('Comments', 'notes'),
        this.headerInvertedSwitch('Active', 'disabled'),
        ...this.hasOverlappingIds ? [this.headerSlot('', 'overlappingIds')] : [],
      ],
      apiRecordCommand: 'diningMealPeriod'
    }
  },
  computed: {
    daysShort () {
      return daysShort
    },
    daysProper () {
      return daysProper
    },
    hasOverlappingIds () {
      return this.items.find(i => i.overlappingIds && !!i.overlappingIds[0])
    },
    showOverlapsDialog: {
      get () {
        return this.showOverlaps && !!this.showOverlaps[0] || false
      },
      set (val) {
        if (!val) {
          this.showOverlaps = []
        }
      }
    },
    mealPeriodLookup () {
      return this.items.reduce((a, m) => {
        a[m.id] = m
        return a
      }, {})
    },
  },
  watch: {
  },
  methods: {
    hasAllDays (item) {
      for (let day of daysProper) {
        if (!item['available' + day]) return false
      }
      return true
    },
    getOrdDay (day) {
      return moment().month(0).date(day).format('Do')
    },
    formatTime (time) {
      return moment(time, 'HH:mm:ss').format('h:mm A')
    },
    getShortMonth (month) {
      return moment().month(month - 1).format('MMM')
    },
    listCommandFilter (command) {
      // return this.addCommandParamArray(command, 'include_fields', ['locationName', 'tableConfigName'])
      return this.addCommandParamArray(command, 'include_fields', ['locationName', 'overlappingIds', 'tableConfigName'])
    },
    openMealPeriod (mpId) {
      this.$router.push({path: '/configuration/meal-periods', query: {sxp: 1, showId: mpId}})
    }
  }
}
</script>
